import { Brush, ClipboardList, Gauge, GitBranch, HardHat, Layers, MoveVertical, PaintBucket, SlidersHorizontal } from "lucide-react";
import GlobalAssumptionsSection from "./sections/GlobalAssumptionsSection";
import LaborBuildupSection from "./sections/LaborBuildupSection";
import SurfacesSection from "./sections/SurfacesSection";
import ProductivitySection from "./sections/ProductivitySection";
import ProductsSection from "./sections/ProductsSection";
import AccessBandsSection from "./sections/AccessBandsSection";
import FinishingMaskingSection from "./sections/FinishingMaskingSection";
import GcTemplatesSection from "./sections/GcTemplatesSection";
import VersionsSection from "./sections/VersionsSection";

// slug → left sub-nav entry. Order = nav order.
export const SETTINGS_SECTIONS = [
  { slug: "global", label: "Global Assumptions", icon: SlidersHorizontal, Component: GlobalAssumptionsSection },
  { slug: "labor", label: "Labor Build-up", icon: HardHat, Component: LaborBuildupSection },
  { slug: "surfaces", label: "Surfaces", icon: Layers, Component: SurfacesSection },
  { slug: "productivity", label: "Productivity", icon: Gauge, Component: ProductivitySection },
  { slug: "products", label: "Products", icon: PaintBucket, Component: ProductsSection },
  { slug: "access-bands", label: "Access Bands", icon: MoveVertical, Component: AccessBandsSection },
  { slug: "finishing-masking", label: "Finishing & Masking", icon: Brush, Component: FinishingMaskingSection },
  { slug: "gc-templates", label: "GC Templates", icon: ClipboardList, Component: GcTemplatesSection },
  { slug: "versions", label: "Versions", icon: GitBranch, Component: VersionsSection },
];

/** Breadcrumb labels for the section slugs (Header auto-formats the rest). */
export const SETTINGS_BREADCRUMBS = Object.fromEntries(SETTINGS_SECTIONS.map((s) => [s.slug, s.label]));
